import { ActivityBuilderModal } from 'approot/activity-builder/activity-builder-modal';
import { NegativeButton } from 'approot/shared/styles/buttons';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { PStyled } from 'approot/shared/styles/typography.style';

type Props = {
  isVisible: boolean;
  isSaving?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const RemoveActivityOutcomeModal = ({
  isVisible,
  isSaving,
  onClose,
  onConfirm,
}: Props) => {
  return (
    <ActivityBuilderModal
      isVisible={isVisible}
      title="Remove outcome and related content points"
      headerTitle="Remove outcome and related content points"
      actions={
        <>
          <NegativeButton
            onClick={onConfirm}
            loading={isSaving}
            disabled={isSaving}
            data-testid="confirm-remove-outcome"
          >
            Yes, remove all
          </NegativeButton>
          <SecondaryButton
            onClick={onClose}
            data-testid="cancel-remove-outcome"
          >
            Cancel
          </SecondaryButton>
        </>
      }
      onClose={onClose}
    >
      <PStyled>
        Removing this outcome will also remove the content points linked to it.
        Are you sure you want to continue?
      </PStyled>
    </ActivityBuilderModal>
  );
};

export default RemoveActivityOutcomeModal;
